module.exports = __webpack_public_path__ + "img/section1Swiper3.3a10d528.png";